import { render, staticRenderFns } from "./Bundles.vue?vue&type=template&id=5144419e&scoped=true&"
import script from "./Bundles.vue?vue&type=script&lang=ts&"
export * from "./Bundles.vue?vue&type=script&lang=ts&"
import style0 from "./Bundles.vue?vue&type=style&index=0&id=5144419e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5144419e",
  null
  
)

export default component.exports